<!--
soho-busyindicator needed here for paging.
-->
<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  [transparentOverlay]="true"
  >
  @if (!showEmptyMessage) {
    <!-- USE FLEX LAYOUT -->
    <div class="scrollable-flex" style="height:100%;">
      <!-- FLEX CONTENT AREA -->
      <div class="scrollable-flex-content" [style.overflow]="'auto'" [class.card]="false">
        <div soho-blockgrid #SohoBlockgrid
          [style.display]="display"
          [style.padding]="padding"
          [selectable]="selectionMode"
          >
          <ng-content select="[content]"></ng-content>
        </div>
      </div>
      <!-- FLEX FOOTER AREA -->
      <ng-content select="[pager]"></ng-content>
    </div>
  } @else {
    <div soho-emptymessage [emptyMessageOptions]="emptyMessageOptions"></div>
  }
</div>
